<template>
  <b-modal
    ref="modal"
    :visible="true"
    :title="title"
    @hide="close"
    size="lg"
  >
    <div v-loading="loading">
      <div
        class="p-3"
        v-for="(log, index) in logs"
        :key="index"
        style="border-bottom: 1px solid #c2cfd6"
      >
        <div v-if="log.isJson" class="">
          <div class="pb-3 row">
            <span class="col-9 bold">
              clientId :
              {{ log.log.clientId ? log.log.clientId : "N/A" }}
            </span>
            <span class="col-3 bold">
              Date :
              {{ log.date ? $getFormattedDate(log.date) : "N/A" }}
            </span>
          </div>
          <div
            v-for="(data, index) in log.log.stockKeepingUnits"
            :key="index"
            class="row"
          >
            <div v-for="(value, key) in data" :key="key" class="col-4 pb-3">
              <span
                class="row pl-3 text-capitalize small"
                style="color: #536c79"
              >
                {{ key }} :
              </span>
              <span class="row pl-3">
                {{ value ? value : "N/A" }}
              </span>
            </div>
          </div>
        </div>
        <div v-else class="text-center">{{ log.log }}</div>
      </div>
    </div>
    <template slot="modal-footer">
      <button type="button" class="btn btn-secondary" @click.prevent="close">
        {{ $t("Close") }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import ApiService from "../services/ApiService";
import DateFormatFiltersMixin from "../mixins/DateFormatFiltersMixin";
export default {
  name: "AppPagePlanEdit",
  mixins: [DateFormatFiltersMixin],
  data() {
    return {
      loading: false,
      logs: [],
      logsData: [],
      isJasonLog: false,
    };
  },
  computed: {
    title() {
      return `${this.$tc("Logs", 1)} ID: ${this.$route.params.log_id}`;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      ApiService.request("GET", "vendors/warehouses", {
        account_id: this.$route.params.id,
        id: this.$route.params.log_id,
        columns: "code,id,name,vendor_id",
        includes: "historyThirdParty",
      })
        .then((response) => {
          if (response.status === 200 && response.data.length === 1) {
            this.logsData = response.data[0];
            if (this.logsData.history_third_party.length > 0) {
              this.logsData.history_third_party.forEach((logInfo) => {
                try {
                  const parsedJson = JSON.parse(logInfo.log);
                  this.logs.push({
                    id: logInfo.id,
                    date: logInfo.created_at,
                    log: parsedJson,
                    isJson: true,
                  });
                } catch {
                  this.logs.push({
                    id: logInfo.id,
                    date: logInfo.created_at,
                    log: logInfo.log,
                    isJson: false,
                  });
                } finally {
                  this.loading = false;
                }
              });
            } else {
              this.logs.push({
                log: "No logs found",
                isJson: false,
              });
              this.loading = false;
            }
          } else {
            console.log("error");
          }
        })
        .catch((e) => {
          console.log("error", e);
        });
    },
    close() {
      this.$router.back();
    },
  },
};
</script>
